import { AnalyticsService } from "./analytics-service";

let analyticsService = new AnalyticsService();

export { analyticsService };